import { render, staticRenderFns } from "./Stackgres.vue?vue&type=template&id=c22136de&scoped=true"
import script from "./Stackgres.vue?vue&type=script&lang=js"
export * from "./Stackgres.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c22136de",
  null
  
)

export default component.exports